import React from 'react';
import { T, fontBody } from '../tokens';

export default function FlowPreviewBar({ preview }) {
  if (!preview) return null;

  return (
    <div style={{
      padding: '10px 22px', background: T.blueSoft, borderBottom: `1px solid ${T.line}`,
      fontFamily: fontBody, fontSize: 12, whiteSpace: 'pre-wrap',
    }}
    >
      <strong>Preview:</strong> {preview}
    </div>
  );
}
